import React from 'react';
import { HISTORY_STATUS_CONFIG } from './interviewShared';

export default function StatusBadge({ status, isDarkMode }) {
  const config = HISTORY_STATUS_CONFIG[status] || HISTORY_STATUS_CONFIG.incomplete;
  const Icon = config.icon;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${config.badgeClass(isDarkMode)}`}>
      <Icon size={13} className={config.iconClass || ''} />
      {config.label}
    </span>
  );
}
